import { type ArchiveItem, type ArchiveState } from '../types';
import { ARCHIVE_WIDGET_SUCCESS, ARCHIVE_WIDGET_FAILURE } from './actions';

const initialState: ArchiveState = {
  archive: [],
  error: undefined,
};

type ArchiveWidgetPayload =
  | { archive: ArchiveItem[]; error?: undefined }
  | { archive?: undefined; error: string };

const archiveWidgetReducer = (
  state: ArchiveState = initialState,
  { type, payload }: { type: string; payload: ArchiveWidgetPayload },
) => {
  switch (type) {
    case ARCHIVE_WIDGET_SUCCESS:
      return { ...state, ...payload };
    case ARCHIVE_WIDGET_FAILURE:
      return { ...state, archive: [], error: payload };
    default:
      return state;
  }
};

export default archiveWidgetReducer;
